import { makeStyles } from '@material-ui/core';

import { useScreen } from '@/hooks/useScreen';
import { DefaultTableColumn } from '@/types/defaultTableColumn';

export const usePasswordRecoveryList = () => {
  const { isMobile } = useScreen();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const classes = useStyles();

  const columnsDesktop: DefaultTableColumn[] = [
    { name: 'id', label: '', align: 'center', colWidth: '6%' },
    { name: 'createdAt', label: 'created_at', align: 'center', colWidth: '26%' },
    { name: 'expirationDate', label: 'expiration_date', align: 'center', colWidth: '26%' },
    { name: 'canBeUsedToChangePassword', label: 'CAN_BE_USED_TO_CHANGE_PASSWORD', align: 'center', colWidth: '21%' },
    { name: 'hasBeenUsed', label: 'HAS_BEEN_USED', align: 'center', colWidth: '21%' },
  ];

  const columnsMobile: DefaultTableColumn[] = [
    { name: 'id', label: '', align: 'center', colWidth: '20%' },
    { name: 'createdAt', label: 'CREATED_AT_FOR_TABLE', align: 'right', colWidth: '20%' },
    { name: 'expirationDate', label: 'EXPIRATION_DATE', align: 'right', colWidth: '20%' },
    { name: 'canBeUsedToChangePassword', label: 'CAN_BE_USED_TO_CHANGE_PASSWORD', align: 'right', colWidth: '20%' },
    { name: 'hasBeenUsed', label: 'HAS_BEEN_USED', align: 'right', colWidth: '20%' },
  ];

  const columns = isMobile ? columnsMobile : columnsDesktop;

  return { classes, columns };
};
